"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgDepartmentSelectorCtrl = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var OrgDepartmentSelectorCtrl = /** @class */ (function () {
    function OrgDepartmentSelectorCtrl(includeOtherAdminOrgs) {
        if (includeOtherAdminOrgs === void 0) { includeOtherAdminOrgs = false; }
        this.includeOtherOrgs = includeOtherAdminOrgs;
    }
    Object.defineProperty(OrgDepartmentSelectorCtrl.prototype, "loadingDepartments", {
        get: function () {
            return services_1.Services.Department.current != null && services_1.Services.Department.departments.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrgDepartmentSelectorCtrl.prototype, "departmentOptions", {
        get: function () {
            var currentDepartment = services_1.Services.Department.current;
            if (currentDepartment == null || currentDepartment.orgId == null) {
                return [];
            }
            var moveableDepartments = services_1.Services.Department.moveableDepartments();
            // For some weird reason office uses the key as the display, and its value as its key on the <option> element????
            return moveableDepartments.map(function (department) { return ({
                key: "".concat(department.displayName).concat(currentDepartment.orgId === department.orgId ? '' : ' (Outside Org)'),
                value: department.objectId
            }); });
        },
        enumerable: false,
        configurable: true
    });
    OrgDepartmentSelectorCtrl.prototype.selectDepartment = function (departmentId) {
        this.selectedDepartmentId = departmentId;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], OrgDepartmentSelectorCtrl.prototype, "selectedDepartmentId", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], OrgDepartmentSelectorCtrl.prototype, "loadingDepartments", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], OrgDepartmentSelectorCtrl.prototype, "departmentOptions", null);
    tslib_1.__decorate([
        mobx_1.action
    ], OrgDepartmentSelectorCtrl.prototype, "selectDepartment", null);
    return OrgDepartmentSelectorCtrl;
}());
exports.OrgDepartmentSelectorCtrl = OrgDepartmentSelectorCtrl;
//# sourceMappingURL=org.department.selector.ctrl.js.map